module.exports = __webpack_public_path__ + "img/illustration-dark.945b7043.svg";